import usePopover from '../../../hooks/usePopover';
import { forwardRef } from 'react';
import { MetadataSelectionPopover } from './MetadataSelectionPopover';
import { AddMetadataButton } from '../building-blocks/AddMetadataButton';
import { MetadataTypeProperties } from '@server/documentation';
import { UI_EVENTS } from '../../../services/events';
import useSendBiEvent from '../../../hooks/useSendBiEvent';

const MAX_TABS = 10;

export const AddMetadata = forwardRef<
  HTMLDivElement,
  {
    onAddMetadata: (tabId: string, isPinned: boolean) => void;
    selectedTypes?: string[];
    compact?: boolean;
    crmOrgId: string;
  }
>(({ onAddMetadata, selectedTypes = [], compact = false, crmOrgId }, ref) => {
  const { isPopoverOpen, openPopover, closePopover, anchorElement, anchorRef } = usePopover();
  const sendBiEvent = useSendBiEvent();

  const handleSelectMetadata = (metadataType: MetadataTypeProperties) => {
    onAddMetadata(metadataType.name, metadataType.pinned);
    sendBiEvent({ name: UI_EVENTS.documentationAddMetadataBrowseTab });
  };

  return (
    <>
      <AddMetadataButton
        ref={(node) => {
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
          anchorRef.current = node;
        }}
        compact={compact}
        disabled={selectedTypes.length >= MAX_TABS}
        isPopoverOpen={isPopoverOpen}
        onClick={openPopover}
      />

      <MetadataSelectionPopover
        isOpen={isPopoverOpen}
        onClose={closePopover}
        anchorEl={anchorElement}
        onSelectMetadata={handleSelectMetadata}
        crmOrgId={crmOrgId}
        selectedTypes={selectedTypes}
      />
    </>
  );
});
